import { useSelector, useDispatch } from 'react-redux';
import * as Styled from '../../styles/ContasAprovados.styles';
import { useEffect, useState } from 'react';
import { detailAccountsFetchAction } from '../../../../store/fetchActions/accountActions';
import { baseIMG } from '../../../../utils/services/api';
import Modal from '../../../../components/Modal/Modal';

export default function DocumentCollum({ contas }) {
  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState(0);
  const [imageURL, setImageURL] = useState('');
  const [imageName, setImageName] = useState('');

  useEffect(() => {
    dispatch(detailAccountsFetchAction(contas.ID_CONTA));
  }, [contas.ID_CONTA]);

  const { documentos } = useSelector(
    (state) => state.account.detailAccountsData
  );

  const changeImage = (newURL, name, index) => {
    setSelectedImage(index);
    setImageURL(newURL);
    setImageName(name);
  };

  useEffect(() => {
    documentos?.length > 0 && setImageURL(documentos[0]?.CAMINHO_ARQUIVO);
  }, []);

  const [isModalImageOpen, setIsModalImageOpen] = useState(false);

  const openModalImage = () => {
    setIsModalImageOpen(true);
  };
  const closeModalImage = () => {
    setIsModalImageOpen(false);
  };

  return (
    <Styled.TaxaContainer>
      <Styled.TitleStyled>Documentos Anexados Conta</Styled.TitleStyled>
      <Styled.DocContainer>
        {documentos?.map((documento, index) => {
          return (
            <Styled.Taxa key={index}>
              <Styled.ImageButton
                index={index}
                selectedImage={selectedImage}
                onClick={() => {
                  changeImage(
                    documento.CAMINHO_ARQUIVO,
                    documento.CATEGORIA,
                    index
                  ),
                    openModalImage();
                }}
              >
                {documento.CATEGORIA}
              </Styled.ImageButton>
            </Styled.Taxa>
          );
        })}
      </Styled.DocContainer>
      <Modal open={isModalImageOpen} close={closeModalImage}>
        <>
          <h1>{imageName}</h1>
          <img src={`${baseIMG}${imageURL}`} />
        </>
      </Modal>
    </Styled.TaxaContainer>
  );
}
